// @ts-nocheck
// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          // Physical, spring-like motion on every button — no instant state flips.
          transition: theme.transitions.create(
            ['box-shadow', 'transform', 'background-color'],
            { duration: 260, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' }
          ),
          '&:active': {
            transform: 'scale(0.97)'
          },
          '&:hover': {
            boxShadow: 'none'
          }
        },
        sizeLarge: {
          height: 50,
          borderRadius: theme.shape.borderRadiusSm,
          fontSize: '0.95rem'
        },
        // contained
        containedInherit: {
          color: theme.palette.grey[800],
          boxShadow: theme.customShadows.z8,
          '&:hover': {
            backgroundColor: theme.palette.grey[400]
          }
        },
        containedPrimary: {
          boxShadow: theme.customShadows.primary,
          '&:hover': {
            boxShadow: theme.customShadows.primary,
            transform: 'translateY(-1px)'
          }
        },
        containedSecondary: {
          boxShadow: theme.customShadows.secondary
        },
        containedInfo: {
          boxShadow: theme.customShadows.info
        },
        containedSuccess: {
          boxShadow: theme.customShadows.success
        },
        containedWarning: {
          boxShadow: theme.customShadows.warning
        },
        containedError: {
          boxShadow: theme.customShadows.error
        },
        // outlined
        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        },
        textInherit: {
          '&:hover': {
            backgroundColor: theme.palette.action.hover
          }
        }
      }
    }
  };
}